export const isWebInDeskApp = (() => {
  const isSSR = import.meta.env.SSR;
  const isEVO = import.meta.env.EVO;
  return (isSSR || isEVO) ? false : navigator.userAgent.includes('QQLive');
})();

export const objectToQueryString = (obj: Record<string, string | number | boolean>): string => Object.entries(obj)
  .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  .join('&');


export const enum VideoTypes {
  PID = 'pid',
  CID = 'cid',
  VID = 'vid'
}


export const getTypeStr = (type: VideoTypes) => {
  switch (type) {
    case VideoTypes.CID:
      return 'cid';
    case VideoTypes.VID:
      return 'vid';
    case VideoTypes.PID:
      return 'pid';
  }
};
